angular.module('admin.directives')

  .directive('clientList', ['Dictionary', 'HelperService', function(Dictionary, helpers){
    return {
      restrict: 'EA',
      controllerAs: 'clientListCtrl',
      bindToController: {
        homes: '='
      },
      scope: {},
      templateUrl: function(el, attrs){
        return attrs.templateUrl || '/admin/templates/partials/client-list.html';
      },

      controller: function(){
        var ctrl = this;
        var dictionary = new Dictionary();

        ctrl.homesFilter = function(home){
          return helpers.homesFilter(home, $scope.homeSearch);
        };

        ctrl.lookup = function(prop,home){
          return dictionary[prop](home);
        };
      },

    }

  }]);
